import {Box, CircularProgress, Typography} from "@mui/material";
import {sx} from './sx'
import {FC} from "react";
import {useTranslation} from "react-i18next";

interface IProps {
    variant?: 'absolute' | 'relative' | 'fullScreen',
    size?:number
}

const SpinnerCustom: FC<IProps> = ({variant = 'absolute',size}) => {

    const{t} = useTranslation()

    if (variant == 'fullScreen') {
        return (
            <Box
                sx={sx.fullScreen}
            >
                <Typography>
                    {t('base.waitLoading')}
                </Typography>
            </Box>
        )
    }

    return (
        <Box
            sx={sx.root}
            className={variant}
        >
            <CircularProgress size={size}/>
        </Box>
    )
};

export default SpinnerCustom;

